import { CSS as MenuCSS } from '../../components/menu/menu.style';

export const CSS = {
	container: 'c-FormMigrateCollections',
	isLoading: 'c-FormMigrateCollections--IsLoading',
	content: 'c-FormMigrateCollections__Content',
	contentSecond: 'c-FormMigrateCollections__Content__second',
	list: 'c-FormMigrateCollections__List',
	menu: 'c-FormMigrateCollections__Menu',
	body: 'c-FormMigrateCollections__Body',
	warningTitle: 'c-FormMigrateCollections__Warning',
	warningBody: 'c-FormMigrateCollections__Warning__Body',
};

export const Style = {
	[CSS.container]: {
		width: '700px',
	},
	[CSS.isLoading]: {
		display: 'flex',
		'justify-content': 'center',
	},
	[CSS.warningTitle]: {
		color: 'red',
		'font-size': '2rem',
		'padding-bottom': '1rem',
	},
	[CSS.warningBody]: {
		'padding-bottom': '1rem',
	},
	[CSS.body]: {
		'padding-bottom': '1rem',
	},
	[CSS.list]: {
		'list-style-type': 'none',
		'padding-left': 0,
	},
	[CSS.menu]: {
		width: '600px',
		position: 'absolute',
		[`& .${MenuCSS.menu}`]: {
			right: 'auto',
			width: '100%',
		},
	},
};
